import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import BatchDataProcAdminListView       from "./BatchDataProcAdminListView";
import BatchDataProcAdminDetailsView    from "./BatchDataProcAdminDetailsView";


const BatchDataProcAdmin = () => {

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "BatchDataProcAdmin.pageState";
  const defaultPageState = {
    searchTermsg: null,
    sortColg: null,
    sortDirg: null,
    perPage:  20,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <BatchDataProcAdminListView pageState={pageState} onUIMode={setUIMode} onSetPageState={setPageState}
                                                            onSetObjDetails={setObjDetails} />                 : null}
      {(uiMode === 'DETAILS') ? <BatchDataProcAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} /> : null}

    </Fragment>
  )
}

export default BatchDataProcAdmin;
